import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ApplicationAdapter {
	constructor(protected _translateService: TranslateService) {}

	protected _buildInfrastructureErrorMessage(methodName: string): string {
		return `${this._translateService.instant(
			`error.infrastructure.${methodName}`
		)}, ${this._translateService.instant('error.infrastructure.common')}`;
	}
}
